import { Component, Inject } from '@angular/core';
import {
  CmsDialogComponent,
  DialogData,
} from '../cms-dialog/cms-dialog.component';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-cms-alert-dialog',
  templateUrl: './cms-alert-dialog.component.html',
  styleUrls: ['./cms-alert-dialog.component.scss'],
})
export class CmsAlertDialogComponent extends CmsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CmsAlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    super(dialogRef, data);
  }
}
